﻿import $ from "jquery";

var campaignBannerListener = (function () {
	function messageHandler(event) {
		if (!window.ccsCampaignBannerListener.isInTrusted(event.origin))
			return;
		var msg = event.data;

		var isMessageReceived = true;
		var data;

		try {
			data = $.parseJSON(msg);

			if (!data.messageType || !data.params) {
				isMessageReceived = false;
			}
		} catch (e) {
			isMessageReceived = false;
		}

		if (!isMessageReceived) {
			return;
		}

		var handlers = $.grep(
			window.ccsCampaignBannerListener.registeredHandlers,
			function (handler) {
				return handler.type && handler.type === data.messageType &&
					handler.id && handler.id === data.messageId;
			});

		if (!handlers)
			return;

		$.each(handlers, function (index, handler) {
			if ($.isFunction(handler.callback)) {
				handler.callback(data.params);
			}
		});
	};

	function ctr() {
		this.trustedDomains = [];
		this.registeredHandlers = [];

		if (window.addEventListener) {
			window.addEventListener("message", messageHandler, false);
		} else {
			window.attachEvent("onmessage", messageHandler);
		}
	}

	ctr.prototype.addTrustedDomain = function (domain) {
		if (this.isInTrusted(domain))
			return;

		this.trustedDomains.push(domain);
	};

	ctr.prototype.isInTrusted = function (domain) {
		return $.inArray(domain, this.trustedDomains) !== -1;
	};
	ctr.prototype.registerHandler = function (id, messageType, messageHanleCallback) {
		var handler = { id: id, type: messageType, callback: messageHanleCallback };
		this.registeredHandlers.push(handler);
	};
	return ctr;
}());

export default window.ccsCampaignBannerListener = window.ccsCampaignBannerListener || new campaignBannerListener();
